export default __webpack_public_path__ + "static/media/Insert_Text_Tab.bf7efb95.svg";